<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4 class="text-capitalize">
                {{ isJobOrderType ? 'Jobs' : 'Orders' }}
                - {{ orderType !== 'job' ? orderType : 'All' }}
            </h4>
            <button class="btn btn-primary"
                    :disabled="loading"
                    @click="newOrder"
                    v-if="orderType !== 'job'">
                New {{ orderType }}
            </button>
        </div>
        <div class="col-12 mb-4 d-sm-flex justify-content-sm-end">
            <b-dropdown variant="outline-secondary text-capitalize"
                        :text="groupText"
                        class="mr-sm-2 mb-sm-0 mb-2 d-sm-flex col-sm-auto col-12 p-0">
                <b-dropdown-item @click="getByGroup('uncompleted')">
                    {{ isJobOrderType ? 'Uncompleted & Uninvoiced' : 'Uncompleted'}}
                </b-dropdown-item>
                <!--<b-dropdown-item @click="getByGroup('uninvoiced')" v-if="isJobOrderType">
                    Uninvoiced
                </b-dropdown-item>-->
                <b-dropdown-item @click="getByGroup('all')">
                    All
                </b-dropdown-item>
            </b-dropdown>
            <DateRangeFilter class="d-sm-flex"
                             :from-date="ordersFromDate"
                             @on-from-input="getByDate({ from: $event })"
                             @on-to-input="getByDate({ to: $event })"
                             :to-date="ordersToDate"
                             :disabled="loading"/>
        </div>
        <AppTable :columns="columns"
                  ref="table"
                  :rows="orders"
                  :query="query"
                  @on-row-click="viewOrder"
                  :loading="loading"
                  :total="total"
                  @on-query-change="onQueryChange"
                  :row-class="rowClass">
            <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'order_lines'">
                <span v-for="order_line in props.row.order_lines" :key="order_line.id">
                    <span v-if="order_line.product">
                        {{ order_line.product.name }},
                    </span>
                    {{ order_line.quantity}}<br>
                </span>
            </span>
                <span v-else-if="props.column.field === 'destination'">
                <span v-for="order_line in props.row.order_lines" :key="order_line.id">
                    <span v-if="order_line.receiving_warehouse">
                        {{ order_line.receiving_warehouse.name }}
                    </span>
                </span>
            </span>
                <span v-else-if="props.column.field === 'status.name'">
                <span class="table__has-indicator text-nowrap" v-if="props.row.status">
                    <strong :style="{color: props.row.status.color}">
                        {{ props.row.status.name }}
                    </strong>
                    <span :style="{background: props.row.status.color}"
                          class="table__indicator ml-1">
                    </span>
                </span>
            </span>
                <span v-else-if="props.column.field === 'job_location' ||
            props.column.field === 'loading_location'">
                    {{ props.row[props.column.field] ? props.row[props.column.field].name : null }}
            </span>
                <span v-else>
                {{props.formattedRow[props.column.field]}}
            </span>
            </template>
        </AppTable>
    </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import { formatDate } from '../../filters/date.filter';
import DateRangeFilter from '../form/DateRangeFilter';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
    DateRangeFilter,
    BDropdown,
    BDropdownItem,
  },
  filters: {
    date: formatDate,
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      orders: 'orders/orders',
    }),
    ...mapState({
      currentOrderId: (state) => state.orders.orderId,
      total: (state) => state.orders.totalOrders,
      ordersFromDate: (state) => state.orders.dates.from,
      ordersToDate: (state) => state.orders.dates.to,
    }),
    orderType() {
      return this.$route.params.orderType;
    },
    isPurchase() {
      return this.orderType === 'purchase';
    },
    isTransfer() {
      return this.orderType === 'transfer';
    },
    isTreatment() {
      return this.orderType === 'treatment';
    },
    isDelivery() {
      return this.orderType === 'delivery';
    },
    isSale() {
      return this.orderType === 'sale';
    },
    query() {
      return this.$store.state.orders.ordersQueries[this.orderType];
    },
    isJobOrderType() {
      return ['treatment', 'delivery', 'sale', 'job'].includes(this.orderType);
    },
    orderNoLabel() {
      if (this.isJobOrderType) {
        return 'Job No';
      }
      if (this.orderType === 'purchase') {
        return 'Order No';
      }
      return 'Transfer No';
    },
    groupText() {
      if (this.query.group === 'uncompleted') {
        return this.isJobOrderType ? 'Uncompleted & Uninvoiced' : 'Uncompleted';
      }
      return this.query.group;
    },
    columns() {
      return [
        {
          label: 'Date',
          field: 'issued_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Delivery due',
          field: 'delivery_due_at',
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy',
          hidden: this.isTreatment || this.isSale,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: this.orderNoLabel,
          field: 'number',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Products & Quantity',
          field: 'order_lines',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Job location',
          field: 'job_location',
          hidden: !this.isJobOrderType,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Logistics',
          field: 'logistics_company.name',
          hidden: this.isJobOrderType,
          filterOptions: {
            enabled: true,
            placeholder: ' ',
          },
        },
        {
          label: 'Destination',
          field: 'destination',
          hidden: this.isJobOrderType,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Invoice No',
          field: 'invoice.number',
          hidden: this.isJobOrderType || this.isTransfer,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Vessel',
          field: 'vessel.name',
          hidden: !this.isJobOrderType || this.isSale,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Client',
          field: 'client_company.name',
          hidden: !this.isJobOrderType,
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Supplier',
          field: 'supplier_company.name',
          hidden: this.orderType !== 'purchase',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Status',
          field: 'status.name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  watch: {
    '$route.params.orderType'() {
      this.$refs.table.reset();
      this.getOrders();
    },
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    newOrder() {
      this.$router.push({
        name: 'order',
        params: {
          orderType: this.orderType,
          id: 'new',
        },
      });
    },
    getByDate(date) {
      this.$store.commit('orders/dateProps', date);
      this.getOrders();
    },
    getByGroup(group) {
      this.updateQueryProps({ group });
      this.getOrders();
    },
    rowClass(order) {
      return order.id === this.currentOrderId ? 'is-active' : '';
    },
    viewOrder(event) {
      if (this.$route.params.id === event.row.id) {
        this.$router.push({ name: 'order' });
        this.$store.commit('orders/orderId', null);
      } else {
        this.$router.push({
          name: 'order',
          params: { id: event.row.id },
        });
      }
    },
    getOrders() {
      this.loading = true;
      this.$store.dispatch('orders/getOrders', this.orderType)
        .finally(() => {
          this.loading = false;
        });
    },
    updateQueryProps(props) {
      this.$store.commit('orders/ordersQueryProps', {
        props,
        type: this.orderType,
      });
    },
    onQueryChange(props) {
      this.updateQueryProps(props);
      this.getOrders();
    },
  },
};
</script>
